// Internal modules
import { logger } from '@/lib/logger';

export const logPrepareCookieBannerToFPTI = (hasContent: boolean): void => {
  logger.fpti('prepare_cookie_banner', {
    is_consent_shown: hasContent ? 1 : 0,
    state_name: 'billing',
    transition_name: 'prepare_cookie_banner',
  });
};
